import React from "react";
import CustomerDetailContainer from "../containers/CustomerDetail";

const CustomerDetail = () => {
  return <CustomerDetailContainer />;
};

export default CustomerDetail;
